import request from "@/api/request";

export const logout = () => {
  return request('post', '/api/users/logout', {})
}
